import React from 'react';
import { Link } from "react-router-dom";

import './bottomNav.css';

export default function BottomNav() {
  return (
    <div className="bottom_nav">
      <div className="p-4">
        <div className="row">
          <div className="col-6">
            <div>
              <Link to={'/jobs'}>
                <i className="icon icon-truck-tick icon-lg text-blue mr-3"></i>
              </Link>
            </div>
          </div>
          <div className="col-6 border-left border-right">
            <Link to={'/payments'}>
              <i className="icon icon-coin icon-lg text-blue mr-3"></i>
            </Link>
          </div>
          {/* <div className="col-4">
            <i className="icon icon-cog text-blue mr-3"></i>
          </div> */}
        </div>
      </div>
    </div>
  )
}
